var $0b04512118591d2a$exports = {};
$0b04512118591d2a$exports = {
  "calendar": "Kalender",
  "day": "dag",
  "dayPeriod": "fm/em",
  "endDate": "Slutdatum",
  "era": "era",
  "hour": "timme",
  "minute": "minut",
  "month": "m\xE5nad",
  "second": "sekund",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "Valt datum: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "Valt intervall: ".concat(args.startDate, " till ").concat(args.endDate);
  },
  "selectedTimeDescription": function selectedTimeDescription(args) {
    return "Vald tid: ".concat(args.time);
  },
  "startDate": "Startdatum",
  "timeZoneName": "tidszon",
  "weekday": "veckodag",
  "year": "\xE5r"
};
export { $0b04512118591d2a$exports as default };